import { setCookie } from '@/utils/cookie';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export default function useAds() {
  const { query } = useRouter();
  useEffect(() => {
    if (!!query.mark_id) {
      setCookie(
        'ads',
        JSON.stringify({
          ads: {
            mark_id: query.mark_id
          }
        }),
        undefined,
        {
          maxAge: 3600 * 24 * 2
        }
      );
    }
  }, [query.mark_id]);
}
